var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.siteInfo.title,
        width: "400px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-bottom": "10px" }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Partners.doorName") } },
                [
                  _c("el-input", {
                    attrs: { no: "name" },
                    model: {
                      value: _vm.siteInfo.name,
                      callback: function($$v) {
                        _vm.$set(_vm.siteInfo, "name", $$v)
                      },
                      expression: "siteInfo.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Payment.contactPerson") } },
                [
                  _c("el-input", {
                    attrs: { no: "contact" },
                    model: {
                      value: _vm.siteInfo.contact,
                      callback: function($$v) {
                        _vm.$set(_vm.siteInfo, "contact", $$v)
                      },
                      expression: "siteInfo.contact"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") } },
                [
                  _c("el-input", {
                    attrs: { no: "phone" },
                    model: {
                      value: _vm.siteInfo.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.siteInfo, "phone", $$v)
                      },
                      expression: "siteInfo.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.DoorAddress") } },
                [
                  _c("el-input", {
                    attrs: { no: "address" },
                    model: {
                      value: _vm.siteInfo.address,
                      callback: function($$v) {
                        _vm.$set(_vm.siteInfo, "address", $$v)
                      },
                      expression: "siteInfo.address"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Payment.remarks") } },
                [
                  _c("el-input", {
                    attrs: { no: "remarks" },
                    model: {
                      value: _vm.siteInfo.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.siteInfo, "remarks", $$v)
                      },
                      expression: "siteInfo.remarks"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_CityP") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "city",
                      cache: false,
                      filterable: "",
                      "default-value": _vm.siteInfo.city,
                      "tag-name":
                        this.$store.getters.language === "zh"
                          ? "chineseName"
                          : "englishName",
                      "tag-value": "code",
                      placeholder: " ",
                      "static-options": _vm.cityList
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.siteInfo.city = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "save", type: "primary" },
              on: { click: _vm.saveSub }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }